// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Sp\u00e4\u0165 na f\u00f3ra";
export const FORUM_ARCHIVED_CAMPAIGN_ACTIVE = "Akt\u00edvne";
